"use client";

import { useCommunicationsSummary } from "@/features/submissions/api/queries/useCommunicationsSummary";
import { useCommunicationsEvents } from "@/features/submissions/hooks/useCommunicationsEvents";

/**
 * Phone-style count badge on the Broker AI nav item: submissions whose
 * comm status is UPDATED — i.e. carrier activity waiting on the broker
 * (GIQS-162). Rendered only inside the Broker AI nav entry, which is
 * already scope-gated by the sidebar. Also hosts the SSE subscription that
 * live-refreshes the communications summary (the sidebar is always mounted).
 */
export function MarketFinderNavBadge({ collapsed }: { collapsed: boolean }) {
  useCommunicationsEvents();
  const { data } = useCommunicationsSummary();
  const count = data?.total_updated ?? 0;
  if (count === 0) return null;

  const label = `${count} submission${count === 1 ? "" : "s"} with new carrier activity`;
  if (collapsed) {
    return (
      <span
        className="absolute top-1 right-0.5 h-2 w-2 rounded-full bg-red-500"
        aria-label={label}
        title={label}
      />
    );
  }
  return (
    <span
      className="ml-auto inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-red-500 px-1.5 text-[11px] font-semibold leading-none text-white"
      aria-label={label}
      title={label}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
